import { provideHttpClient, withFetch } from '@angular/common/http';
import {ApplicationConfig, ErrorHandler} from '@angular/core';
import * as Sentry from "@sentry/angular-ivy";
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: true,
      }),
    },
    provideHttpClient(withFetch()),
    provideRouter(routes),
    provideClientHydration()
  ]
};
